import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c07f3bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_2 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_3 = {
  class: "ant-col",
  style: {"flex":"0 0 200px","text-align":"left"}
}
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_16 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-13" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_22 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 5 }
const _hoisted_32 = { key: 6 }
const _hoisted_33 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xl-12" }, null, -1))
const _hoisted_35 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_37 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_estoque = _resolveComponent("selecionar-estoque")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createBlock(_component_a_skeleton, {
    loading: _ctx.telaBase.carregando,
    paragraph: { rows: 5 }
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        key: _ctx.props.empresa
      }, [
        (_ctx.props.preSelecao.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_busca_geral, {
                  empresas: _ctx.telaBase.empresasSelecionadas,
                  ordenacao: _ctx.gradeBase.ordenacaoSelecionada,
                  "onUpdate:ordenacao": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
                  buscaRapida: _ctx.state.buscaRapida,
                  "onUpdate:buscaRapida": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
                  buscaAvancada: _ctx.gradeBase.buscaAvancada,
                  "onUpdate:buscaAvancada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
                  onBuscarDados: _ctx.buscarProdutos
                }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "onBuscarDados"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_checkbox, {
                  style: {"margin-left":"8px"},
                  checked: _ctx.state.apenasComSaldo,
                  "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.apenasComSaldo) = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarProdutos()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Apenas com saldo")
                  ]),
                  _: 1
                }, 8, ["checked"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form, {
          class: "ss-alinhar-texto-esquerda",
          layout: "vertical"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_card, {
                  titulo: "PRODUTOS",
                  class: "ss-padding-separacao-esquerda"
                }, {
                  default: _withCtx(() => [
                    ((_ctx.props.tipoSelecao === _ctx.ETipoSelecaoProduto.SelecaoUnica || _ctx.props.tipoSelecao === _ctx.ETipoSelecaoProduto.SelecaoMultipla) && _ctx.props.preSelecao.length === 0)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 'CHAVE-BUSCA-PRODUTOS' + _ctx.state.chaveProdutos,
                          ref: "scrollContainer",
                          onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
                          style: _normalizeStyle('height: ' + _ctx.defineAlturaScroll(30) +'px;overflow-y: auto;')
                        }, [
                          _createVNode(_component_a_table, {
                            class: _normalizeClass('ss-grade'),
                            rowClassName: _ctx.obterClasseLinha,
                            columns: _ctx.state.colunas.filter(item => item.visible),
                            "data-source": _ctx.state.produtosVisiveis,
                            rowKey: "codigoDefinicao",
                            pagination: false,
                            carregandoProdutos: _ctx.telaBase.carregando,
                            scroll: _ctx.gradeBase.layoutMobile ? null : { x: (_ctx.gradeBase.windowWidth + 500) },
                            size: "small",
                            "row-selection": { selectedRowKeys: _ctx.computedCodigosSelecionados, onChange: _ctx.selecaoAlterada,  },
                            customRow: _ctx.rowHandlers
                          }, {
                            bodyCell: _withCtx(({ column, record, text }) => [
                              (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(text), 1))
                            ]),
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, {
                                resultadoPesquisa: !_ctx.telaBase.carregando,
                                mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum produto encontrado...'
                              }, null, 8, ["resultadoPesquisa", "mensagem"])
                            ]),
                            _: 1
                          }, 8, ["rowClassName", "columns", "data-source", "carregandoProdutos", "scroll", "row-selection", "customRow"])
                        ], 36))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 'CHAVE-BUSCA-PRODUTOS1' + _ctx.state.chaveProdutos,
                          ref: "scrollContainer",
                          onScroll: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
                          style: _normalizeStyle('height: ' + _ctx.defineAlturaScroll(30) +'px;overflow-y: auto;')
                        }, [
                          _createVNode(_component_a_table, {
                            class: _normalizeClass('ss-grade'),
                            rowClassName: _ctx.obterClasseLinha,
                            columns: _ctx.state.colunas.filter(item => item.visible),
                            "data-source": _ctx.state.produtosVisiveis,
                            rowKey: "codigo",
                            pagination: false,
                            carregandoProdutos: _ctx.telaBase.carregando,
                            scroll: { x: 800 },
                            size: "small",
                            customRow: _ctx.rowHandlers
                          }, {
                            bodyCell: _withCtx(({ column, record, text }) => [
                              (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(text), 1))
                            ]),
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, {
                                resultadoPesquisa: !_ctx.telaBase.carregando,
                                mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum produto encontrado...'
                              }, null, 8, ["resultadoPesquisa", "mensagem"])
                            ]),
                            _: 1
                          }, 8, ["rowClassName", "columns", "data-source", "carregandoProdutos", "customRow"])
                        ], 36)),
                    ((_ctx.computedProdutos.length !== _ctx.state.produtosVisiveis.length))
                      ? (_openBlock(), _createBlock(_component_a_alert, {
                          key: 2,
                          message: "Role para baixo para carregar mais produtos.",
                          type: "info",
                          "show-icon": "",
                          closable: ""
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.state.indexProdutoSelecionado > -1 && _ctx.UtilitarioGeral.objetoValido(_ctx.computedProdutos[_ctx.state.indexProdutoSelecionado]) && _ctx.UtilitarioGeral.validaLista(_ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].estoquesRastreabilidades))
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 0,
                      titulo: "DISPONIBILIDADE DE ESTOQUE"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_spin, {
                          spinning: _ctx.state.carregandoEstoque
                        }, {
                          default: _withCtx(() => [
                            (_ctx.props.preSelecao.length > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].tipoRastreabilidade === _ctx.ETipoRastreabilidade.Nenhum)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Produto",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                value: _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].codigoInterno + ' - ' + _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].produto,
                                                disabled: ""
                                              }, null, 8, _hoisted_12)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Estoque",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_selecionar_estoque, {
                                                "codigo-selecionado": _ctx.state.estoqueSelecionado,
                                                "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.estoqueSelecionado) = $event)),
                                                empresas: [_ctx.props.empresa]
                                              }, null, 8, ["codigo-selecionado", "empresas"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Quantidade",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_campo_numerico, {
                                                valor: _ctx.state.qtdSelecionada,
                                                "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.qtdSelecionada) = $event)),
                                                "quantidade-casas-decimais": _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].casasDecimais
                                              }, null, 8, ["valor", "quantidade-casas-decimais"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                          _createVNode(_component_a_form_item, {
                                            label: " ",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("button", {
                                                class: "ant-btn ant-btn-secondary",
                                                style: {"width":"100%"},
                                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.adicionarQuantidade && _ctx.adicionarQuantidade(...args)))
                                              }, "Adicionar")
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Produto",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                value: _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].codigoInterno + ' - ' + _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].produto,
                                                disabled: ""
                                              }, null, 8, _hoisted_18)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Identificador da Rastreabilidade",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.rastreabilidadeSelecionada) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.rastreabilidadeSelecionada]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_20, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Quantidade",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_campo_numerico, {
                                                valor: _ctx.state.qtdSelecionada,
                                                "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.qtdSelecionada) = $event)),
                                                "quantidade-casas-decimais": _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].casasDecimais
                                              }, null, 8, ["valor", "quantidade-casas-decimais"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                          _createVNode(_component_a_form_item, {
                                            label: " ",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("button", {
                                                class: "ant-btn ant-btn-secondary",
                                                style: {"width":"100%"},
                                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.adicionarQuantidade && _ctx.adicionarQuantidade(...args)))
                                              }, _toDisplayString(_ctx.state.editarQtd ? 'Editar' : 'Adicionar'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]))
                                ], 64))
                              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Produto",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          type: "text",
                                          class: "ant-input",
                                          value: _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].codigoInterno + ' - ' + _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].produto,
                                          disabled: ""
                                        }, null, 8, _hoisted_24)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])),
                            _createVNode(_component_a_table, {
                              class: _normalizeClass(_ctx.props.preSelecao.length > 0 ? 'ss-tamanho-grade-modal' : 'ss-tamanho-grade'),
                              columns: _ctx.state.colunasEstoques.filter(item => item.visible),
                              "data-source": _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].estoquesRastreabilidades,
                              rowKey: "codigo",
                              pagination: false,
                              scroll: { y: _ctx.state.windowHeight },
                              size: "small"
                            }, {
                              bodyCell: _withCtx(({ column, record, text, index }) => [
                                (column.key === 'acoes')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("a", {
                                        class: "visualizar",
                                        title: "Detalhes do Produto",
                                        onClick: ($event: any) => (_ctx.editarQuantidade(index))
                                      }, [
                                        _createVNode(_component_icone, { nome: "editar" })
                                      ], 8, _hoisted_26)
                                    ]))
                                  : (column.key === 'Densidade')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.UtilitarioGeral.validaLista(record.controles) && record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.Densidade))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.Densidade)?.valor, 2) + ' ' + record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.Densidade)?.unidadeMedida), 1))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (column.key === 'Ph')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          (_ctx.UtilitarioGeral.validaLista(record.controles) && record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.PH))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.PH)?.valor, 2) + ' ' + record.controles.find((c) => c.tipoControle === _ctx.ETipoControleProducao.PH)?.unidadeMedida), 1))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 3,
                                            onClick: ($event: any) => (_ctx.editarQuantidade(index))
                                          }, [
                                            _createVNode(_component_icone, { nome: "editar" })
                                          ], 8, _hoisted_29))
                                        : (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 4,
                                              onClick: ($event: any) => (_ctx.preencherIdentificador(index))
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString(text), 1)
                                            ], 8, _hoisted_30))
                                          : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                            : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, record.casasDecimais, false, true)), 1))
                                              : _createCommentVNode("", true)
                              ]),
                              emptyText: _withCtx(() => [
                                _createVNode(_component_mensagem_sem_dados, {
                                  resultadoPesquisa: !_ctx.telaBase.carregando,
                                  mensagem: _ctx.telaBase.carregando ? 'Buscando informações, por favor aguarde...' : 'Nenhum registro foi encontrado!'
                                }, null, 8, ["resultadoPesquisa", "mensagem"])
                              ]),
                              _: 1
                            }, 8, ["class", "columns", "data-source", "scroll"]),
                            (_ctx.UtilitarioGeral.validaLista(_ctx.props.preSelecao))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _hoisted_34,
                                  _createElementVNode("div", _hoisted_35, [
                                    (_ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].quantidade > 0)
                                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                                          key: 0,
                                          label: "Qtd do Produto",
                                          class: "ss-margin-campos"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.state.qtdProduto,
                                              "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.qtdProduto) = $event)),
                                              "casas-decimais": _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].casasDecimais,
                                              disabled: true
                                            }, null, 8, ["valor", "casas-decimais"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Total Selecionado",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          valor: _ctx.state.qtdTotalSelecionada,
                                          "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.qtdTotalSelecionada) = $event)),
                                          "casas-decimais": _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].casasDecimais,
                                          disabled: true
                                        }, null, 8, ["valor", "casas-decimais"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Qtd Restante",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          valor: _ctx.state.qtdRestante,
                                          "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.qtdRestante) = $event)),
                                          "casas-decimais": _ctx.computedProdutos[_ctx.state.indexProdutoSelecionado].casasDecimais,
                                          disabled: true
                                        }, null, 8, ["valor", "casas-decimais"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["spinning"])
                      ]),
                      _: 1
                    }))
                  : (_ctx.state.indexProdutoSelecionado > -1)
                    ? (_openBlock(), _createBlock(_component_card, {
                        key: 1,
                        style: {"min-height":"calc(50vh - 50px)"},
                        titulo: "DISPONIBILIDADE DE ESTOQUE"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum estoque disponível" })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_card, {
                        key: 2,
                        style: {"min-height":"calc(50vh - 50px)"},
                        titulo: "DISPONIBILIDADE DE ESTOQUE"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum produto selecionado" })
                        ]),
                        _: 1
                      }))
              ])
            ])
          ]),
          _: 1
        })
      ]))
    ]),
    _: 1
  }, 8, ["loading"]))
}